import React, {Component} from 'react';
import HeaderComponent
    from "../../../Components/HeaderComponent/HeaderComponent";
import {Typography} from "@material-ui/core";
import SpacerComponent
    from "../../../Components/SpacerComponent/SpacerComponent";
import MessageUtil from "../../../Utils/MessageUtil";
import ListNewAwardScreen from "../NewAward/ListNewAwardScreen";

import GeneralTranslation
    from "../../../Translations/FormValidations/GeneralTranslation";
import FormCampaignMetaScreen from "./FormCampaignMetaScreen";
import CampaignValidation from "../../../FormValidations/CampaignValidation";
import CampaignService from "../../../Services/CampaignService";
import ListCampaingScreen from "../NewAward/ListCampaingScreen";
import CampaignMetaValidation
    from "../../../FormValidations/CampaignMetaValidation";
import ListCampaignMetaScreen from "./list/ListCampaingMetaScreen";
import {CampaingMetaContext} from "../../../Contexts/CampaignMetaContext";

class CampaignMetaScreen extends Component {
    static ROUTE = '/campaign-meta';

    constructor(props) {
        super(props);

        this.state = {
            inLoad: false,
            messagens: null,
            fidelity: [],
            companies: [],
            action: 'create',
            actionToHuman: 'cadastrada',
            actionCurrent: 'Registrar Nova Campanha por meta',
        };

        this.campaignService = new CampaignService();
    }

    componentDidMount() {
        this.isEdit();
    }

    doCreate = async (object) => {
        try {
            const validate = await CampaignMetaValidation.validate(object);

            if (validate !== true) {
                this.setState({
                    erros: validate,
                    messagens: MessageUtil.makeToValidationField(
                        new GeneralTranslation(validate).translate()
                    ),
                });
                return;
            }

            const request = this.prepareApiRequest(object);

            console.log('doCreate');
            console.log(request);

            this.setState({
                inLoad: true,
            });

            if (!this.state.isEdit) {
                await this.campaignService.createCampaignMeta(request);
            }

            if (this.state.isEdit) {
                await this.campaignService.patchClientGoal({
                    uuid: request.uuid,
                    object: request,
                });
            }

            this.setState({
                inLoad: false,
                messagens: MessageUtil.make({
                    title: 'Sucesso',
                    body: `Campanha ${this.state.actionToHuman}, clique em ok para voltar.`,
                    okBtnToRoute: ListCampaignMetaScreen.ROUTE,
                }),
            });

        } catch (e) {
            this.setState({
                inLoad: false,
                messagens: MessageUtil.make({
                    title: 'Atenção',
                    body: e,
                }),
            });
        }
    }

    prepareApiRequest(formData) {
        if (!formData) return {};

        const clientUuids = formData.client_uuids || undefined;

        return {
            uuid: formData?.uuid ?? undefined,
            goal_title: formData?.goal_title,
            company_uuid: formData.company_uuid || "",
            client_uuids: clientUuids,
            top_percent: formData?.top_percent ?? undefined,
            targets: [
                {
                    period: formData.period,
                    goal_type: formData.goal_type,
                    goal_value: Number(formData.goal_value ?? 0),
                    reward_type: formData.reward_type,
                    reward_points: formData.reward_points,
                    award: formData.reward_type === 'award' ? {
                        title: formData.title,
                        description: formData.description,
                        rules: formData.rules,
                        amount: formData.amount,
                    } : undefined
                }
            ]
        };
    }

    async isEdit() {

        try {
            if (this.props.match.params.edit === undefined) {
                this.setState({
                    isEdit: false,
                });
                return;
            }

            this.setState({
                inLoad: true,
            });

            const response = await this.campaignService.showClientGoal(this.props.match.params.edit);

            this.setState({
                isEdit: true,
                inLoad: false,
                formEdit: response.data.data,
                action: 'edit',
                actionToHuman: 'alterada',
                actionCurrent: 'Visualizar Campanha por meta',
            });

        } catch (e) {
            this.setState({
                inLoad: false,
                messagens: MessageUtil.make({
                    title: 'Atenção',
                    body: e,
                }),
            });
        }
    }

    doDelete = async (uuid) => {
        try {
            const message = MessageUtil.make({
                title: 'Atencao',
                body: 'Deseja realmente deletar essa campanha por meta, essa ação não pode ser recuperada.',
                okButtonText: 'Sim',
                okButtonFunction: async () => {
                    this.setState({
                        inLoad: true,
                    });

                    await this.campaignService.deleteClientGoal(uuid);

                    this.setState({
                        inLoad: false,
                        messagens: MessageUtil.make({
                            title: 'Sucesso',
                            body: 'Campanha por meta foi deletada',
                            okBtnToRoute: ListCampaignMetaScreen.ROUTE,
                        }),
                    });
                },
                cancelButtonText: 'Não',
                cancelButtonFunction: () => {
                }
            });

            this.setState({
                messagens: message,
            });

        } catch (e) {
            this.setState({
                inLoad: false,
                messagens: MessageUtil.make({
                    title: 'Atenção',
                    body: e,
                }),
            });
        }
    }

    render() {
        return (
            <CampaingMetaContext.Provider value={{
                parent: this,
            }}>
                <HeaderComponent title={'Campanha por meta'}
                                 menu={true}
                                 inLoad={this.state.inLoad}
                                 messagens={this.state.messagens}/>
                <Typography align={'center'}
                            variant={'h6'}
                            color={'primary'}>
                    {this.state.actionCurrent}
                </Typography>
                <SpacerComponent height={40}/>
                <FormCampaignMetaScreen doCreate={this.doCreate}
                                        erros={this.state.erros}
                                        formEdit={this.state.formEdit}
                                        doDelete={this.doDelete}/>
            </CampaingMetaContext.Provider>
        );
    }
}

export default CampaignMetaScreen;